@import "tailwindcss";

html, body {
  margin: 0;
  overflow-x: hidden;
}

body {
  font-family: system-ui, -apple-system, sans-serif;
  -webkit-font-smoothing: antialiased;
  -webkit-tap-highlight-color: transparent;
}

button {
  touch-action: manipulation;
}

#root {
  min-height: 100svh;
}
